import { Routes } from '@dtx-company/true-common/src/constants/routes'
import { useRouter } from 'next/router'

export function useIsFlowpage(): boolean {
  const router = useRouter()

  return router.pathname === Routes.FLOWPAGE
}
